import ItemsHorizontalScroll from "../../shared/itemsHorizontalScroll/itemsHorizontalScroll";
import ItemBackdropDetails from "../../shared/item-backdrop-details/item-backdrop-details";
import React, {ReactNode} from "react";
import {getLocalDateTimeString} from "../../../../utils/utils";
import {LeagueEvent} from "../../../../apis/towers-sports-api/types";
import {useNavigate} from "react-router-dom";
import {ScrollModal, ScrollModalApi} from "../../../shared/scroll-modal";
import {OptionButton} from "../../../shared/option-button";
import SquadflixRowTitle from "../squadflixRowTitle/squadflixRowTitle";
import {useSpanishLeagueEventsData} from "../../hooks/useCatalogRowData";
import {
    isLeagueGameFinished as isGameFinished,
    isLeagueGameStarted as isGameStarted,
    leagueGameStartsToday as gameStartsToday
} from "../../hooks/useLiveChannelDetailsData";

const SpanishLeagueEventsRow = (props: SquadflixRowsBaseProps) => {

    const {events: upcomingEvents} = useSpanishLeagueEventsData();
    const navigate = useNavigate();
    const optionsModal = React.useRef<ScrollModalApi>(null);
    const [selectedEvent, setSelectedEvent] = React.useState<LeagueEvent>(null);

    const getBottomRightOverlay = (item: LeagueEvent): ReactNode | null => {
        if (gameStartsToday(item) && !isGameStarted(item)) {
            const gameDate = getLocalDateTimeString(item.strTimestamp + "Z");
            // delete seconds from gameDate
            const gameDateWithoutSeconds = gameDate.slice(0, -3);
            const timeOnly = gameDateWithoutSeconds.split(" ")[1];
            return <>
                <i className="fa-solid fa-clock"></i> Hoy a las {timeOnly}
            </>
        }
        if (isGameStarted(item) && !item.acestreamEvent?.enlaces?.length) {
            return <>Sin Enlaces ❌</>;
        }
        return null;
    }

    return (
        <div style={{height: "fit-content", overflow: "hidden", order: props.order ?? 0}}>
            <SquadflixRowTitle
                {...props}
                title={"Futbol España"}
                icon={<img
                    src={"https://torresowo.myftp.org/cap17drive/v2/files/9f1587d2a9b38408dd0fc50a96067cd7"}
                    alt="La Liga"
                    style={{
                        width: "19px",
                        height: "19px",
                        objectFit: "contain",
                        marginRight: "1px",
                        borderRadius: "4px",
                    }}/>}/>
            <ItemsHorizontalScroll>
                <div className="d-flex flex-row gap-3" style={{paddingLeft: "13px", paddingRight: "13px"}}>
                    {upcomingEvents.map((item) => {
                        const gameDate = getLocalDateTimeString(item.strTimestamp + "Z");
                        // delete seconds from gameDate
                        const gameDateWithoutSeconds = gameDate.slice(0, -3);
                        const timeOnly = gameDateWithoutSeconds.split(" ")[1];
                        if (isGameFinished(item)) {
                            return null;
                        }
                        return (<div key={item.idEvent}>
                            <ItemBackdropDetails
                                onClickPoster={() => {
                                    if (!isGameStarted(item)) return;
                                    if (!item.acestreamEvent?.enlaces?.length) return;
                                    navigate(`/squadflix/live-event/${item.idEvent}/0`);
                                }}
                                onClickDetails={() => {
                                    if (!item.acestreamEvent?.enlaces?.length) return;
                                    setSelectedEvent(item);
                                    optionsModal.current?.open();
                                }}
                                style={{
                                    width: "min(300px, 59vw)",
                                    position: "relative",
                                }}
                                overlay={{
                                    center: item.acestreamEvent?.enlaces?.length && isGameStarted(item) &&
                                        <i className="fa-solid fa-play fa-xl" style={{
                                            padding: "10px 7px",
                                        }}></i>,
                                    bottomRight: getBottomRightOverlay(item)
                                }}
                                cachedSrc={item.strThumb}
                                detailsInfo={
                                    isGameStarted(item) ? "En vivo" : "Próximo evento"
                                }
                                hideOptionsIcon={!item.acestreamEvent?.enlaces?.length}
                                detailsTitle={item.strEvent}
                                detailsSubtitle={gameDateWithoutSeconds}
                            />
                        </div>)
                    })}
                </div>
            </ItemsHorizontalScroll>
            <ScrollModal ref={optionsModal} header={<div>
                <ItemBackdropDetails
                    style={{
                        pointerEvents: "none",
                        width: "100%",
                        padding: "20px 20px 20px",
                        position: "relative",
                    }}
                    overlay={{
                        bottomRight: <div>Enlaces
                            disponibles: {selectedEvent?.acestreamEvent?.enlaces?.length || 0}</div>,
                        topLeft: <h3>
                            {selectedEvent?.strEvent}
                        </h3>
                    }}
                    cachedSrc={selectedEvent?.strThumb}
                />
            </div>}>
                {selectedEvent?.acestreamEvent?.enlaces?.map((link, index) => {
                    return (<OptionButton onClick={() => {
                        navigate(`/squadflix/live-event/${selectedEvent.idEvent}/${index}`);
                    }} text={link.name} icon={undefined}/>)
                })}
            </ScrollModal>
        </div>
    )
};

export default SpanishLeagueEventsRow;
